import { GeographicEntityListPage } from '@/components/geographic/GeographicEntityListPage'
import { geographicEntities } from '@/config/geographicEntities'

export default function ProvincesPage() {
  return <GeographicEntityListPage config={geographicEntities.provinces} />
}
